import { useContext } from 'react';
import { PlaybackStoreApi, PlaybackStoreContext } from './playback.context';

/**
 * Hook to get the playback store API. Throws if no PlaybackProvider exists.
 */

export function usePlaybackStoreApiContext(): PlaybackStoreApi {
  const ctx = useContext(PlaybackStoreContext);

  if (!ctx?.store) {
    throw new Error('usePlaybackStoreApiContext must be inside a PlaybackProvider');
  }

  return ctx.store;
}
